import { createStore } from 'vuex'
import Cookies from 'js-cookie'


const store = createStore({
  state: {
    duvets: [
      {
        id: 1,
        size: '140x200',
        thickness: 'całoroczna',
        weight: '900',
        price: 899, 
      },
      {
        id: 2,
        size: '140x200',
        thickness: 'zimowa',
        weight: '1000',
        price: 949, 
      },
      {
        id: 3,
        size: '160x200',
        thickness: 'całoroczna',
        weight: '1100',
        price: 999, 
      },
      {
        id: 4,
        size: '160x200',
        thickness: 'zimowa',
        weight: '1200',
        price: 1049, 
      },
      {
        id: 5,
        size: '200x200',
        thickness: 'całoroczna',
        weight: '1500',
        price: 1199, 
      },
      {
        id: 6,
        size: '200x200',
        thickness: 'zimowa',
        weight: '1600',
        price: 1249, 
      },
      //{
      // id: 7,
      //  size: '100x140',
      //  thickness: 'całoroczna',
      //  weight: '500',
      //  price: 700, 
      //},
      //{
      //  id: 8,
      //  size: '100x140',
      //  thickness: 'zimowa',
      //  weight: '550',
      //  price: 750, 
      //},
      {
        id: 9,
        size: '160x220',
        thickness: 'całoroczna',
        weight: '1300',
        price: 1099, 
      },
      {
        id: 10,
        size: '160x220',
        thickness: 'zimowa',
        weight: '1400',
        price: 1149, 
      },
      {
        id: 11,
        size: '200x220',
        thickness: 'całoroczna',
        weight: '1700',
        price: 1299, 
      },
      {
        id: 12,
        size: '200x220',
        thickness: 'zimowa',
        weight: '1800',
        price: 1349, 
      },
    ],
    cartProducts: [],
    buyerData: [],
    orderNum: [],

    user: null,
    token: null,
  },
  getters: {
    //DUVETS
    getDuvets: state => {return state.duvets},
    getDuvetsSizes: state => {
      var sizes = state.duvets.map(duvet => duvet.size)
      return [...new Set(sizes)];
    },
    getDuvetsThickness: state => {
      var thickness = state.duvets.map(duvet => duvet.thickness)
      return [...new Set(thickness)];
    },
    getDuvetPrice: (state) => (size, thickness) => {
      var pricedata = [state.duvets.find(duvet => duvet.size === size && duvet.thickness === thickness)]
      return pricedata.map(duvet => duvet.price);
    },
    getDuvetWeight: (state) => (size, thickness) => {
      var weightdata = [state.duvets.find(duvet => duvet.size === size && duvet.thickness === thickness)]
      return weightdata.map(duvet => duvet.weight);
    },
    getDuvetID: (state) => (size, thickness) => {
      var iddata = [state.duvets.find(duvet => duvet.size === size && duvet.thickness === thickness)]
      return iddata.map(duvet => duvet.id);
    },
    //PILLOWS
    //getPillows: state => state.pillows,
    
    //CART
    getProdInCart: state => state.cartProducts,
    getCurrentProduct: state => state.currentProduct,

    //USER
    getUserData: state => state.buyerData,
    isLoggedIn(state) {
      return !!state.token;
    },

    //ORDER
    getOrderNum: state => state.orderNum,
  },
  mutations: {
    ADD_PRODUCT: (state, product) => {
      state.cartProducts.push(product);
    },
    REMOVE_PRODUCT: (state, index) => {
      state.cartProducts.splice(index, 1);
    },
    CURRENT_PRODUCT: (state, product) => {
      state.currentProduct = product;
    },
    CHANGE_QUANTITY: (state, data) => {
      state.cartProducts[data.index].quantity = data.quantity;
      state.cartProducts[data.index].price = data.price;
    },

    STORE_USER: (state, data) => {
      state.buyerData = [];
      state.buyerData.push(data);
    },
    STORE_ORDER_NUM: (state, data) => {
      state.orderNum = [];
      state.orderNum.push(data);
    },

    CLEAR_UC: (state) => {
      state.buyerData.splice(0, state.buyerData.length);
      state.cartProducts.splice(0, state.cartProducts.length);
    },

    SET_USER_LOGIN: (state, user) => {
      state.user = user;
    }, 
    SET_TOKEN_LOGIN: (state, token) => {
      state.token = token;
    },
    LOGOUT: (state) => {
      state.user = null;
      state.token = null;
    } 
  },
  actions: {
    //Cart Products
    addProduct: (context, product) => {
      context.commit('ADD_PRODUCT', product);
    },
    removeProduct: (context, index) => {
      context.commit('REMOVE_PRODUCT', index);
    },
    currentProduct: (context, product) => {
      context.commit('CURRENT_PRODUCT', product);
    },
    changeQuantity: (context, data) => {
      context.commit('CHANGE_QUANTITY', data)
    },

    //User Data
    storeUserData: (context, buyer) => {
      context.commit('STORE_USER', buyer);
    },
    setUser: (context, user) => {
      context.commit('SET_USER_LOGIN', user);
    },
    setToken: (context, token) => {
      context.commit('SET_TOKEN_LOGIN', token);
    },
    logout: (context) => {
      context.commit('LOGOUT');
    },

    //Order Num
    storeOrderNumber: (context, order) => {
      context.commit('STORE_ORDER_NUM', order);
    },

    //ResetUser&Cart
    clearUserCart: (context) => {
      context.commit('CLEAR_UC');
    },

    //getUserData: (contex t, index) => {
    //  context.commit('GET_USER', index);
    //}
  },
  plugins: [],
});

const loadStateFromCookie = () => {
  const cookieData = Cookies.get('datacookies');
  return cookieData ? JSON.parse(cookieData) : undefined;
};

const initialState = loadStateFromCookie();

if (initialState) {
  store.replaceState(initialState);
}

store.subscribe((mutation, state) => {
  Cookies.set('datacookies', JSON.stringify(state), { expires: 1 });
});

export default store;